import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { api, BACKEND_URL } from "@/lib/api";
import { BeforeAfter } from "@/components/BeforeAfter";

const POLL_MS = 4000;
const MAX_POLLS = 60;

export const PreviewResult = ({ token, beforeSrc }) => {
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    let polls = 0;
    let timer;
    const check = async () => {
      polls += 1;
      try {
        const { data } = await api.get(`/public/previews/${token}`);
        if (data.status !== "pending") { setStatus(data.status); return; }
      } catch { /* keep polling */ }
      if (polls < MAX_POLLS) timer = setTimeout(check, POLL_MS); else setStatus("failed");
    };
    timer = setTimeout(check, POLL_MS);
    return () => clearTimeout(timer);
  }, [token]);

  if (status !== "pending" && status !== "done") return null;
  return (
    <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-soft" data-testid="preview-result" data-status={status}>
      <p className="flex items-center gap-2 text-sm font-semibold text-slate-900"><Sparkles className="h-4 w-4 text-[color:var(--brand)]" />Your finished-space preview</p>
      {status === "pending" ? (
        <div className="mt-4 flex aspect-[4/3] flex-col items-center justify-center gap-3 rounded-xl bg-slate-50 text-sm text-slate-600 ring-1 ring-slate-200" data-testid="preview-creating">
          <Loader2 className="h-7 w-7 animate-spin text-[color:var(--brand)]" />
          Creating your preview...
          <span className="text-xs text-slate-400">This usually takes 15-30 seconds</span>
        </div>
      ) : (
        <div className="mt-4"><BeforeAfter before={beforeSrc || `${BACKEND_URL}/api/public/previews/${token}/before`} after={`${BACKEND_URL}/api/public/previews/${token}/after`} testId="preview-compare" /></div>
      )}
    </div>
  );
};
